/* lua.js generated code undefined */

SpineUtil = table()
let animPool = table()
let UNVISIBLE = 9999
SpineUtil.hideAnim = function (anim) {
    let self = this
    if (anim) {
        anim.setVisible(false)
        // let name = tostring(anim)
        // let {x: x, y: y}  = anim.getPosition()
        // if (x === UNVISIBLE && y === UNVISIBLE) {
        //     return 
        // }
        // if (animPool[name]) {
        //     animPool[name].anim = anim
        // } else {
        //     animPool[name] = table(
        //         [1, "anim", anim],
        //         [1, "x", x],
        //         [1, "y", y]
        //     )
        // }
        // anim.setPosition(UNVISIBLE, UNVISIBLE)
    }
}
SpineUtil.showAnim = function (anim) {
    let self = this
    anim.setVisible(true)
    return
    let name = tostring(anim)
    let data = animPool[name]
    if (data && !data.anim) {
        let [x, y] = [data.x, data.y]
        data.anim.setPosition(x, y)
        animPool[name] = null
    }
}
